import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import * as ProjectActions from './project.actions';
import { ProjectService } from '../../state-services/project.service';
import { Router } from '@angular/router';

@Injectable()
export class ProjectEffects {
  constructor(
    private actions$: Actions,
    private projectService: ProjectService,
    private router: Router,
  ) {}

  loadProjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectActions.loadProjects),
      mergeMap(() =>
        this.projectService.getAllProjects().pipe(
          map((projects) => ProjectActions.loadProjectsSuccess({ projects })),
          catchError((error) =>
            of(ProjectActions.loadProjectsError({ error })),
          ),
        ),
      ),
    ),
  );

  loadProjectById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectActions.loadProjectById),
      mergeMap(({ projectId }) =>
        this.projectService.getProjectById(projectId).pipe(
          map((project) => {
            if (project) {
              this.projectService.project = project;
              return ProjectActions.loadProjectByIdSuccess({
                project: project,
              });
            } else {
              return ProjectActions.loadProjectByIdError({
                error: 'project not found',
              });
            }
          }),
          catchError((error) =>
            of(ProjectActions.loadProjectByIdError({ error })),
          ),
        ),
      ),
    ),
  );

  loadProjectByIdError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProjectActions.loadProjectByIdError),
        tap(() => {
          this.router.navigate(['/progress']);
        }),
      ),
    { dispatch: false },
  );

  createProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectActions.createProject),
      mergeMap((action) =>
        this.projectService.createProject(action.project).pipe(
          map((project) => ProjectActions.createProjectSuccess({ project })),
          catchError((error) =>
            of(ProjectActions.createProjectError({ error })),
          ),
        ),
      ),
    ),
  );

  updateProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectActions.updateProject),
      mergeMap((action) =>
        this.projectService
          .updateProject(action.projectId, action.project)
          .pipe(
            map((project) => ProjectActions.updateProjectSuccess({ project })),
            catchError((error) =>
              of(ProjectActions.updateProjectError({ error })),
            ),
          ),
      ),
    ),
  );

  deleteProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectActions.deleteProject),
      mergeMap((action) =>
        this.projectService.deleteProject(action.projectId).pipe(
          map(() =>
            ProjectActions.deleteProjectSuccess({
              projectId: action.projectId,
            }),
          ),
          catchError((error) =>
            of(ProjectActions.deleteProjectError({ error })),
          ),
        ),
      ),
    ),
  );
}
